import { Footer, TitleBar } from '../../../../../components';
import { useParams } from 'react-router';
import QueryErrorBoundary from '../../../../../components/error-handling';
import TitleUpdater from '../../../../../components/common/TitleUpdater';
import { ApplicationDescriptionTable } from '../../../../../components/business-functions/ApplicationDescriptionTable';
import {
  useBusinessFunctionData,
  useBusinessFunctionITApplications,
} from '../../../../../hooks/business-functions/queries';
import { useUpdateITApplicationComment } from '../../../../../hooks/business-functions/mutations';

const BusinessFunctionsApplicationDescription = () => {
  const { businessFunctionId = '' } = useParams();

  const { businessFunctionName, businessFnError } =
    useBusinessFunctionData(businessFunctionId);
  const {
    itApplicationsData,
    loading: itAppsLoading,
    error: itAppsError,
  } = useBusinessFunctionITApplications([businessFunctionId]);
  const updateITApplicationComment = useUpdateITApplicationComment();

  return (
    <QueryErrorBoundary error={businessFnError}>
      <TitleUpdater title={`${businessFunctionName}/IT App Summary`} />
      <TitleBar
        title="Enterprise Business Function Tagging"
        subtitle={`${businessFunctionName} Application Descriptions`}
        brief={`In the table below, describe why each application is important to ${businessFunctionName}.`}
      />
      <ApplicationDescriptionTable
        itAppsData={itApplicationsData}
        loading={itAppsLoading}
        error={itAppsError}
        businessFunctionId={businessFunctionId}
        updateITApplicationComment={updateITApplicationComment}
      />
      <Footer
        backPath={`/cyber/enterprise-level/business-functions/${businessFunctionId}/it-application-selection`}
        nextPath="/cyber/enterprise-level/business-functions"
        goNextText="Overview"
      />
    </QueryErrorBoundary>
  );
};

export default BusinessFunctionsApplicationDescription;
